import Vue, { VueConstructor } from 'vue'
import ToastContainer from './ToastContainer.vue'

const toastPlugin = {
   install(vue: VueConstructor, options: ToasterOptions) {
      const root = new ToastContainer()

      if (!!options) {
         ;(root as IToaster).setDefaults(options)
      }

      root.$mount(document.body.appendChild(document.createElement('div')))

      vue.prototype.$toast = root
      vue.$toast = root as IToaster
   },
}

export default toastPlugin
